import React from "react";
import { Grid, Row, Col, Nav } from "react-bootstrap";
import { Switch, Route, Redirect } from "react-router";

//import NetzwerkContainer from "./NetzwerkContainer";
import BenutzerContainer from "./BenutzerContainer";
import RightsContainer from "./RightsContainer";
import EinheitenContainer from "./EinheitenContainer";
import EmailContainer from "./EmailContainer";
import DruckContainer from "./DruckContainer";
import ShareContainer from "./ShareContainer";
//import ZeitContainer from "./ZeitContainer";

import AlmigLink from "../grundelemente/AlmigLink";
import BreadcrumbContainer from "../grundelemente/BreadcrumbContainer";
import OnlyTimeInfoPanel from "../grundelemente/OnlyTimeInfoPanel";

import "./Einstellungen.css";

const Einstellungen = () => (
	<Grid className="Einstellungen">
		<Row>
			<Col xs={12}>
				<BreadcrumbContainer />
			</Col>
		</Row>
		<Row>
			<Col sm={12} md={3}>
				<Nav stacked className="Navispalte">
					{/*<AlmigLink to="/settings/network" />*/}
					<AlmigLink to="/settings/users" />
					<AlmigLink to="/settings/rights" />
					<AlmigLink to="/settings/dimensions" />
					<AlmigLink to="/settings/email" />
					<AlmigLink to="/settings/print" />
					<AlmigLink to="/settings/share" />
					{/*<AlmigLink to="/settings/time" />*/}
				</Nav>
			</Col>
			<Col sm={12} md={6} className="Mittelspalte">
				<Switch>
					{/*<Route path="/settings/network" component={NetzwerkContainer} />*/}
					<Route path="/settings/users" component={BenutzerContainer} />
					<Route path="/settings/rights" component={RightsContainer} />
					<Route path="/settings/dimensions" component={EinheitenContainer} />
					<Route path="/settings/email" component={EmailContainer} />
					<Route path="/settings/print" component={DruckContainer} />
					<Route path="/settings/share" component={ShareContainer} />
					{/*<Route path="/settings/time" component={ZeitContainer} />*/}
					<Redirect exact from="/settings" to="/settings/users" />
				</Switch>
			</Col>
			<Col sm={12} md={3}>
				<OnlyTimeInfoPanel />
			</Col>
		</Row>
	</Grid>
);

export default Einstellungen;
